import { defineMessages } from 'react-intl';

export default defineMessages({
	requests: {
		defaultMessage: 'Requests',
		description: 'Requests item in hub avatar menu',
		id: 'hub.avatar.menu.requests',
	},
	approvals: {
		defaultMessage: 'Approvals',
		description: 'Approvals item in hub avatar menu',
		id: 'hub.avatar.menu.approvals',
	},
});
